module.exports = __webpack_public_path__ + "media/images/hitfun3/bg.howtoprize-57ad5b4dccd337c0a3f687af15bf7554.svg";